module.exports = __webpack_public_path__ + "static/media/dice_0.64abf4b2.svg";